<template>
  <v-card :hover="true">
    <h4>
      <v-icon medium color="yellow">lock_open</v-icon>
      Login
    </h4>
    <form ref="form" xs12>
      <v-flex>
        <v-alert
          v-if="alert"
          :type="alert.type"
          dismissible
          v-model="showAlert"
        >
          {{ alert.message }}
        </v-alert>
      </v-flex>
      <v-text-field
        v-model="email"
        v-validate="'required|email'"
        :error-messages="errors.collect('email')"
        data-vv-name="email"
        data-vv-validate-on="change"
        prepend-icon="email"
        color="primary"
        label="Email address"
        type="email"
        required
      ></v-text-field>
      <v-text-field
        v-model="password"
        v-validate="'required'"
        :error-messages="errors.collect('password')"
        data-vv-name="password"
        prepend-icon="vpn_key"
        :append-icon="showPassword ? 'visibility_off' : 'visibility'"
        :type="showPassword ? 'text' : 'password'"
        class="input-group--focused"
        @click:append="showPassword = !showPassword"
        color="primary"
        label="Password"
        required
      ></v-text-field>
      <v-checkbox
        v-model="agreement"
        v-validate="'required'"
        :error-messages="errors.collect('agreement')"
        data-vv-name="agreement"
        color="primary"
        value="1"
        required
      >
        <template ma-0 pa-0 v-slot:label>
          I agree to the&nbsp;
          <router-link to="/terms" target="_blank">
            Terms of Service
          </router-link>
          &nbsp;and&nbsp;
          <a
            href="https://www.evidentscientific.com/en/privacy"
            target="_blank"
          >
            Privacy Policy
          </a>
          *
        </template>
      </v-checkbox>
      <v-layout align-start row>
        <v-flex xs2><v-btn flat @click="clear">Clear</v-btn></v-flex>
        <v-flex xs4>
          <v-btn
            :loading="loading"
            class="white--text"
            color="primary"
            type="submit"
            @click="submit"
            depressed
          >
            Sign in
          </v-btn>
        </v-flex>
      </v-layout>
    </form>
  </v-card>
</template>

<script>
import { mapState } from "vuex";

export default {
  $_veeValidate: {
    validator: "new"
  },
  data() {
    return {
      email: "",
      password: "",
      agreement: null,
      showAlert: false,
      showPassword: false
    };
  },
  methods: {
    clear() {
      this.email = "";
      this.password = "";
      this.agreement = null;
      this.showAlert = false;
      this.showPassword = false;
      this.$refs.form.reset();
      this.$validator.reset();
    },
    submit(event) {
      event.preventDefault();
      this.$validator.validateAll().then(valid => {
        if (!this.loading && valid) {
          this.$store.dispatch("auth/userSignIn", {
            email: this.email,
            password: this.password
          });
        }
      });
    }
  },
  computed: mapState("auth", ["alert", "loading"]),
  watch: {
    alert(value) {
      if (value) {
        this.showAlert = true;
      }
    },
    showAlert(value) {
      if (!value) {
        this.$store.commit("auth/setAlert", null);
      }
    }
  }
};
</script>
